var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M8.83 6a30.23 30.23 0 0 0-5.62 5.406A.949.949 0 0 0 3 12m5.83 6a30.233 30.233 0 0 1-5.62-5.406A.949.949 0 0 1 3 12m0 0h18","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})
}
var staticRenderFns = []

export { render, staticRenderFns }